import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import { createSelector } from 'reselect';
import { createAction, createReducer } from 'redux-act';
import ConfigBag from '@gandi/config-bag';

function getConfig(state) {
  var configBag = new ConfigBag();
  configBag.merge(state.config);
  return configBag;
}
/**
 * Return the value of the config corresponding to the key `key`.
 * @param  {String} key
 * @param  {Mixed}  defaultValue
 * @return {Mixed}
 */


export var selectFromConfig = function selectFromConfig(key, defaultValue) {
  return createSelector(getConfig, function (config) {
    return config.get(key, defaultValue);
  });
};
export var initConfig = createAction('Init configuration');
export var configReducer = createReducer(_defineProperty({}, initConfig.getType(), function (state, payload) {
  return _objectSpread(_objectSpread({}, state), payload);
}), {});